export const applySizeInlineStyle = ({ width, maxWidth, minWidth, height, maxHeight, minHeight, }) => {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (width && { width })), (maxWidth && { maxWidth })), (minWidth && { minWidth })), (height && { height })), (maxHeight && { maxHeight })), (minHeight && { minHeight }));
};
